import React from 'react'
import { COLORES } from '../../../../config/colores'
import { Button } from '@material-ui/core'

function TipoDePesado (props) {
  const { setTipoPesado, tipoPesado } = props

  return (
    <>
      <Button
        variant={tipoPesado === 'circuito' ? 'contained' : 'outlined'}
        size='small'
        style={{
          color: (tipoPesado === 'circuito') ? '#ffffff' : 'inherit',
          backgroundColor: (tipoPesado === 'circuito') ? COLORES.grey.dark : 'inherit',
          margin: '1%'
        }}
        onClick={() => { setTipoPesado('circuito') }}
      >
        Producto en circuito
      </Button>

      <Button
        variant={tipoPesado === 'Pesado subproducto' ? 'contained' : 'outlined'}
        size='small'
        style={{
          color: (tipoPesado === 'Pesado subproducto') ? '#ffffff' : 'inherit',
          backgroundColor: (tipoPesado === 'Pesado subproducto') ? COLORES.grey.dark : 'inherit',
          margin: '1%'
        }}
        onClick={() => { setTipoPesado('Pesado subproducto') }}
      >
            Pesado subproducto
      </Button>
    </>
  )
}

export default TipoDePesado
